import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, exec } = useRequest({
    name: 'GET_PROCESS_LIST',
    url: '/api/system/processes?is_complete_tree=1',
    manual: false,
  });
  return [data || [], exec];
});
